import {ProductBadgesPageContext} from '../context'
import useProductBadgesOperations from '../hooks/useProductBadgesOperations'
import useGetProductBadgesList from '../hooks/useGetProductBadgesList'
import {Pagination} from '../../../utils/pagination'
import usePermission from '../../../hook/usePermission'
import ProductBadgesHeader from '../sections/headers/ProductBadgesHeader'
import ProductBadgesTable from '../sections/tables/ProductBadgesTable'

export default function ProductBadges() {
  const {
    productBadgesList,
    pagination,
    isLoading,
    filters,
    onSearch,
    onPageChange,
    onSortingChange,
  } = useGetProductBadgesList()

  const {
    deleteProductBadge,
    toggleProductBadgeStatus,
    isOperationLoading,
  } = useProductBadgesOperations()

  const {hasPermission} = usePermission()
  const hasWritePermission = hasPermission('products_product badges', 'write') || false

  const contextValue = {
    hasWritePermission,
    productBadgesList,
    isLoading,
    filters,
    onSearch,
    onSortingChange,
    deleteProductBadge,
    toggleProductBadgeStatus,
    isOperationLoading,
  }

  return (
    <ProductBadgesPageContext.Provider value={contextValue}>
      <ProductBadgesHeader />
      <ProductBadgesTable />
      <Pagination pagination={pagination} onPageChange={onPageChange} />
    </ProductBadgesPageContext.Provider>
  )
}
